module.exports = __webpack_public_path__ + "static/media/base_curves_icon.609e90a9.png";